'use strict';

import { SavedDesigns } from './saved_designs.ts';
import { CustomerOrderSearch } from '../tv_customer_orders/customer_orders.ts';

// Hides empty cells on mobile account page
function fix_order_cells() {
    let tv_screen_width = window.innerWidth;
    let tv_responsive_blocks = Array.from(document.getElementsByClassName('ty-table__responsive-content'));
    const tv_order_cells = Array.from(document.getElementsByClassName('tv-order-cell'));

    if (tv_screen_width <= 767) {
        // Handle initial table load
        tv_order_cells.forEach(tv_order_cell => {
            if (tv_order_cell.innerText == "") {
                tv_order_cell.classList.add('tv-display__none');
            }
        });
        // Handle resizing after table has loaded
        tv_responsive_blocks.forEach(tv_responsive_block => {
            if (tv_responsive_block.innerText == "") {
                tv_responsive_block.parentElement.classList.add('tv-display__none');
            }
        });
    } else {
        tv_order_cells.forEach(tv_order_cell => {
            tv_order_cell.classList.remove('tv-display__none');
        });
    }

}

// Initialize the SavedDesigns view.
export function init_saved_designs() {
    if (document.getElementById('tv-customer-records__saved-designs')) {
        new SavedDesigns();
    }
}

// Initialize.
export function init() {
    init_saved_designs();
    fix_order_cells();
    window.onresize = fix_order_cells;
    
    // Initialize pay now and fast order status functionality on customer profile page
    new CustomerOrderSearch();
}
